import { Observable } from 'rxjs';
import { TpvMsiPlan } from '@app/domain/models/tpv/msi.model';

/**
 * Port de lectura de los planes de Meses Sin Intereses (MSI) disponibles para
 * un comercio. `id_merchant` (UUID) es obligatorio. Devuelve un arreglo plano
 * (no paginado).
 */
export abstract class MsiRepository {
  abstract getMsiPlans(externalIdMerchant: string): Observable<TpvMsiPlan[]>;
}
